import { Checkbox, Collapse, Space } from "antd";
import { ReactComponent as BottomArrowIcon } from "../../../../../../assets/svg/bottom-arrow.svg";
import { useTranslation } from "react-i18next";
import FilterDrawer from "../../../../FilterDrawer/FilterDrawer";
import styles from "./FilterSidebar.module.css";

const FilterSidebar = (props) => {
  const {
    filter_open,
    closeFilterHandler,
    filter_list = [],
    checkbox_change,
    clear_filter,
    submit_filter,
  } = props;

  const { i18n } = useTranslation();

  const items = filter_list
    .filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id)
    )
    .map((filter_item, filter_item_index) => {
      if (filter_item.list.length) {
        return {
          styles: {
            header: {
              fontWeight: "700",
            },
          },
          key: filter_item.key,
          label:
            i18n.language === "en"
              ? filter_item.label
              : filter_item.translation
              ? filter_item.translation
              : filter_item.label,
          children: (
            <Space
              direction="vertical"
              style={{
                width: "100%",
              }}
            >
              {filter_item.list.map((sub_item, sub_item_index) => (
                <Checkbox
                  key={sub_item.id}
                  checked={sub_item.active}
                  className={styles.checkbox}
                  onChange={(e) => {
                    checkbox_change(
                      filter_item_index,
                      sub_item_index,
                      e.target.checked
                    );
                  }}
                >
                  <span
                    className="text-style"
                    dir={sub_item.translation ? "rtl" : "ltr"}
                  >
                    {i18n.language === "en"
                      ? sub_item.label
                      : sub_item.translation
                      ? sub_item.translation
                      : sub_item.label}
                  </span>
                </Checkbox>
              ))}
            </Space>
          ),
        };
      } else {
        return null;
      }
    });

  return (
    <FilterDrawer
      open={filter_open}
      closeHandler={closeFilterHandler}
      clearFilter={clear_filter}
      submitFilter={submit_filter}
    >
      <Collapse
        ghost
        expandIconPosition="end"
        expandIcon={({ isActive }) => (
          <BottomArrowIcon
            transform={`rotate(${isActive ? 180 : 0})`}
            width="10px"
          />
        )}
        items={items.filter(Boolean)}
      />
    </FilterDrawer>
  );
};

export default FilterSidebar;
